module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/point01-68774cd086489ffc4c4c32a2f4860281.png";